import { SHIPMENT_GROUPING, SHIPMENT_TRACKING_TYPES } from '@/lib/constants';
import { ShipmentGrouping, ShipmentModel } from '@/lib/models/shipment/types';

export type TrackingType = (typeof SHIPMENT_TRACKING_TYPES)[keyof typeof SHIPMENT_TRACKING_TYPES] | undefined;

export type TrackingTypeAndValue = {
  type: TrackingType;
  value: string | undefined;
};

export const getTrackingTypeAndValue = (
  {
    containerNumber,
    mblNumber,
    awbNumber,
    bookingNumber,
    parcelNumber,
    associatedContainers,
  }: {
    containerNumber?: string;
    mblNumber?: string;
    awbNumber?: string;
    bookingNumber?: string;
    parcelNumber?: string;
    associatedContainers?: ShipmentModel['associatedContainers'];
  },
  grouping?: ShipmentGrouping,
): TrackingTypeAndValue => {
  if (associatedContainers?.length) {
    if (grouping) {
      if (grouping === SHIPMENT_GROUPING.MBOL && mblNumber) {
        return { type: SHIPMENT_TRACKING_TYPES.MBL_NUMBER, value: mblNumber };
      }
      if (grouping === SHIPMENT_GROUPING.BOOKING_NUMBER && bookingNumber) {
        return { type: SHIPMENT_TRACKING_TYPES.BOOKING_NUMBER, value: bookingNumber };
      }
    }
    if (bookingNumber) {
      return { type: SHIPMENT_TRACKING_TYPES.BOOKING_NUMBER, value: bookingNumber };
    }
    return { type: SHIPMENT_TRACKING_TYPES.MBL_NUMBER, value: mblNumber };
  }

  if (containerNumber) {
    return { type: SHIPMENT_TRACKING_TYPES.CONTAINER_NUMBER, value: containerNumber };
  }
  if (mblNumber) {
    return { type: SHIPMENT_TRACKING_TYPES.MBL_NUMBER, value: mblNumber };
  }
  if (awbNumber) {
    return { type: SHIPMENT_TRACKING_TYPES.AWB_NUMBER, value: awbNumber };
  }
  if (bookingNumber) {
    return { type: SHIPMENT_TRACKING_TYPES.BOOKING_NUMBER, value: bookingNumber };
  }
  if (parcelNumber) {
    return { type: SHIPMENT_TRACKING_TYPES.PARCEL_NUMBER, value: parcelNumber };
  }
  return { type: undefined, value: undefined };
};
